import {createAction} from '@reduxjs/toolkit'

import {BookingManagementToSearchRedirectParams} from '../../../utils/bookingManagement/getHotelSearchParams'

type BookingPageRedirectParams = {
  bookingId: string
  anonymousId: string
  locale: string
  userCountry: string
  showBackButton: boolean
  isMobile: boolean
}

type PaymentPageRedirectParams = {
  bookingId: string
  locale: string
  isSamePage?: boolean
}

export const navigateToSearch = createAction(
  'bookingNavigation/navigateToSearch'
)

export const navigateToHotelSearch =
  createAction<BookingManagementToSearchRedirectParams>(
    'bookingNavigation/navigateToHotelSearch'
  )

export const navigateToPaymentPage = createAction<PaymentPageRedirectParams>(
  'bookingNavigation/navigateToPaymentPage'
)

export const navigateToBooking = createAction<BookingPageRedirectParams>(
  'bookingNavigation/navigateToBooking'
)
